var Producer = /** @class */ (function () {
    function Producer(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
    }
    Producer.prototype.getFullNumber = function () {
        if (!(this.branchOffice && this.number)) {
            return '';
        }
        return String(this.branchOffice).padStart(2, '0') + "-" + String(this.number).padStart(6, '0');
    };
    Producer.prototype.getFullName = function () {
        if (this.name && this.name.length) {
            return this.name;
        }
        if (this.firstName && this.lastName && this.firstName.length && this.lastName.length) {
            return this.firstName + " " + this.lastName;
        }
    };
    return Producer;
}());
export { Producer };
